import { useState, useEffect, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";

export const useDriverRemainingTime = (taskId) => {
  const [remainingTime, setRemainingTime] = useState(null);
  const [totalTime, setTotalTime] = useState(null);
  const [acknowledgeTime, setAcknowledgeTime] = useState(null);
  const [driverStatus, setDriverStatus] = useState(null);

  //  useCallback with dependencies
  const fetchRemainingTime = useCallback(async () => {
    if (!taskId) {
      // console.log(" SKIP: No taskId");
      return;
    }

    // console.log(" GET_DRIVER_REMAINING_TIME CALL", taskId);

    try {
      const res = await axiosInstance.post(
        ENDPOINTS.GET_DRIVER_REMAINING_TIME,
        { taskId }
      );

      // console.log(" GET_DRIVER_REMAINING_TIME RESPONSE", res?.data);

      if (res?.data?.responseCode === "00") {
        const raw = res.data.data?.[0];
        
        if (!raw) {
          // console.log("No data in response");
          setRemainingTime(null);
          setTotalTime(null);
          setAcknowledgeTime(null);
          setDriverStatus(null);
          return;
        }

        const newRemainingTime = raw.remaining_time != null ? Number(raw.remaining_time) : null;
        const newTotalTime = raw.total_time != null ? Number(raw.total_time) : null;
        const newAckTime = raw.acknowledge_time || null;
        const newDriverStatus = raw.driver_status || null;

        // console.log(" Setting state:", {
        //   remainingTime: newRemainingTime,
        //   totalTime: newTotalTime,
        //   acknowledgeTime: newAckTime,
        //   driverStatus: newDriverStatus,
        // });

        setRemainingTime(newRemainingTime);
        setTotalTime(newTotalTime);
        setAcknowledgeTime(newAckTime);
        setDriverStatus(newDriverStatus);
      } else {
        console.warn(" Response code not 00:", res?.data?.responseCode);
      }
    } catch (error) {
      console.error(" GET_DRIVER_REMAINING_TIME ERROR:", error);
    }
  }, [taskId]); //  taskId is the only dependency

  return {
    remainingTime,
    totalTime,
    acknowledgeTime,
    driverStatus,
    fetchRemainingTime,
  };
};